(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awards"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    document.querySelectorAll('.aw-sec').forEach(function(sec){
      if(sec.dataset.ready) return; sec.dataset.ready='1';
      var lb=sec.querySelector('[data-aw-lb]'), im=lb.querySelector('[data-aw-lb-img]'), cap=lb.querySelector('[data-aw-lb-cap]'), last;
      function close(){lb.hidden=true;im.src='';document.documentElement.classList.remove('qz-lock');if(last)last.focus();}
      sec.addEventListener('click',function(e){
        var b=e.target.closest('[data-aw-full]');
        if(b){last=b;im.src=b.dataset.awFull;im.alt=b.dataset.awCap;cap.textContent=b.dataset.awCap;lb.hidden=false;document.documentElement.classList.add('qz-lock');lb.querySelector('.aw-lb-x').focus();return;}
        if(!lb.hidden&&(e.target===lb||e.target.closest('.aw-lb-x')))close();
      });
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!lb.hidden)close();});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-feed"] && !Shopify.designMode) return;
  try {
    
(function(){
  function strip(html){var d=document.createElement('div');d.innerHTML=html||'';return (d.textContent||'').replace(/\s+/g,' ').trim();}
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function norm(s){return String(s||'').toLowerCase().replace(/[^a-z0-9]/g,'');}
  function init(root){
    if(root.dataset.ready) return; root.dataset.ready='1';
    var site=root.dataset.site, limit=parseInt(root.dataset.limit,10)||6, all=root.dataset.all==='1';
    var fixedTag=root.dataset.tag||'';
    var grid=root.querySelector('[data-grid]'), status=root.querySelector('[data-status]');
    var more=root.querySelector('[data-more]'), search=root.querySelector('[data-search]');
    var chips=[].slice.call(root.querySelectorAll('.jf-chip'));
    var labels=chips.filter(function(c){return c.dataset.topic;}).map(function(c){return {label:c.textContent.trim(),keys:c.dataset.topic.split(',').map(norm).filter(Boolean)};});
    var posts=[], topic='', query='', shown=all?12:limit, page=1, found=Infinity, loading=false;
    var api='https://public-api.wordpress.com/rest/v1.1/sites/'+encodeURIComponent(site)+'/posts/?fields=ID,title,URL,date,excerpt,featured_image,tags,categories&number='+(all?100:Math.max(limit*3,12));
    var base=api, tagMode='tag';
    function slug(t){return t.toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
    if(fixedTag) api=base+'&tag='+encodeURIComponent(slug(fixedTag));
    function terms(p){var t=[];['tags','categories'].forEach(function(k){if(p[k])Object.keys(p[k]).forEach(function(n){t.push(norm(n));var s=p[k][n]&&p[k][n].slug;if(s)t.push(norm(s));});});return t;}
    function load(){
      if(loading||posts.length>=found) return Promise.resolve();
      loading=true;
      return fetch(api+'&page='+page).then(function(r){if(!r.ok)throw new Error(r.status);return r.json();}).then(function(j){
        found=j.found||0; page++;
        (j.posts||[]).forEach(function(p){p._t=terms(p);p._s=norm(strip(p.title)+' '+strip(p.excerpt));posts.push(p);});
        loading=false;
        if(all&&posts.length<found&&page<=10) return load();
      });
    }
    function match(p){
      if(topic){var keys=topic.split(',').map(norm).filter(Boolean);if(!keys.some(function(k){return p._t.indexOf(k)>-1;}))return false;}
      if(query){var q=query.split(/\s+/).map(norm).filter(Boolean);if(!q.every(function(w){return p._s.indexOf(w)>-1;}))return false;}
      return true;
    }
    function card(p){
      var title=strip(p.title), ex=strip(p.excerpt); if(ex.length>170) ex=ex.slice(0,167).replace(/\s+\S*$/,'')+'…';
      var d=new Date(p.date), date=isNaN(d)?'':d.toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});
      var tags=labels.filter(function(l){return l.keys.some(function(k){return p._t.indexOf(k)>-1;});}).slice(0,3);
      var img=p.featured_image?'<div class="jf-img" style="background-image:url(\''+esc(String(p.featured_image).split('?')[0])+'?w=640\')"></div>':'<div class="jf-img" aria-hidden="true">✦</div>';
      return '<a class="jf-card" href="'+esc(p.URL)+'" target="_blank" rel="noopener">'+img+'<div class="jf-body"><span class="jf-date">'+esc(date)+'</span><h3>'+esc(title)+'</h3>'+(ex?'<p>'+esc(ex)+'</p>':'')+(tags.length?'<div class="jf-tags">'+tags.map(function(t){return '<span class="jf-tag">'+esc(t.label)+'</span>';}).join('')+'</div>':'')+'<span class="jf-read">Read the post →</span></div></a>';
    }
    function render(){
      var list=posts.filter(match);
      grid.innerHTML=list.slice(0,shown).map(card).join('');
      status.textContent=list.length?'':(posts.length?'No posts match that yet. Try another topic or word.':'No posts yet.');
      if(more) more.hidden=!(all&&list.length>shown);
    }
    chips.forEach(function(c){c.addEventListener('click',function(){chips.forEach(function(x){x.classList.toggle('is-on',x===c);});topic=c.dataset.topic;shown=12;render();});});
    if(search){var t;search.addEventListener('input',function(){clearTimeout(t);t=setTimeout(function(){query=search.value.trim();shown=12;render();},200);});}
    if(more) more.addEventListener('click',function(){shown+=12;render();});
    var params=new URLSearchParams(location.search);
    if(params.get('q')&&search&&!root.dataset.qUsed){root.dataset.qUsed='1';query=params.get('q');search.value=query;}
    if(params.get('topic')){var want=norm(params.get('topic'));chips.forEach(function(c){if(c.dataset.topic&&(norm(c.textContent)===want||c.dataset.topic.split(',').map(norm).indexOf(want)>-1)){chips.forEach(function(x){x.classList.toggle('is-on',x===c);});topic=c.dataset.topic;}});}
    function start(){return load().then(function(){
      if(fixedTag&&tagMode==='tag'&&!posts.length){tagMode='category';api=base+'&category='+encodeURIComponent(slug(fixedTag));page=1;found=Infinity;return start();}
    });}
    start().then(render).catch(function(){status.innerHTML='The Journal couldn’t load right now. <a href="https://'+esc(site)+'" target="_blank" rel="noopener">Read it at '+esc(site)+'</a>.';});
  }
  function boot(){document.querySelectorAll('[data-journal]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    document.querySelectorAll('[data-qc-search]').forEach(function(inp){
      if(inp.dataset.ready) return; inp.dataset.ready='1';
      var sec=inp.closest('.qc-sec'), cards=[].slice.call(sec.querySelectorAll('.qc-card')), none=sec.querySelector('[data-qc-none]');
      inp.addEventListener('input',function(){
        var q=inp.value.trim().toLowerCase(), n=0;
        cards.forEach(function(c){var ok=!q||c.dataset.qcText.indexOf(q)>-1;c.hidden=!ok;if(ok)n++;});
        none.hidden=n>0;
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
